import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import ApiService from "../../../ApiService";
import DispatchProps from "../../../../utils/DispatchProps";
import PageTitle from "../../../PageTitle";
import HelpBox from "../HelpBox";
import {IRootState} from "../../../../store";
import Table, {TableColumn} from "../../../Table";
import LoadingPage from "../../../LoadingPage";

interface ContainerImageDashboardPageProps
{
    apiService: ApiService;
}

interface ContainerImageDashboardPageState
{
    imageNames?: string[];
}

const imageColumns: TableColumn[] = [
    {
        title: "Image Name",
        propertyPath: "imageName",
        flex: 1
    }
];

class ContainerImageDashboardPage extends Component<ContainerImageDashboardPageProps & DispatchProps, ContainerImageDashboardPageState> {

    constructor(props: ContainerImageDashboardPageProps & DispatchProps) {
        super(props);

        this.state = {
        }
    }

    async componentDidMount() {

        const imageNames = await this.props.apiService.getContainerImageNames();

        this.setState({
            imageNames: imageNames
        });
    }

    async componentDidUpdate(prevProps: Readonly<ContainerImageDashboardPageProps & DispatchProps>, prevState: Readonly<ContainerImageDashboardPageState>, snapshot?: any): Promise<void>
    {

    }

    public render(): JSX.Element {
        
        
        if(this.state.imageNames === undefined)
        {
            return <LoadingPage/>;
        }

        const imageNameItems = this.state.imageNames.map(imageName => {
            return {
                imageName: imageName
            };
        });
        
        return (
            <Fragment>
                <PageTitle title={`Container Images`} />

                <HelpBox
                    TitleText="Manange Container Image Tags"
                    HelpBoxText={""}
                    Icon={'Tag'}
                />
                
                <Table
                    title={"Container Images"}
                    columns={imageColumns}
                    items={imageNameItems}
                    rowPropsForItem={(i: {imageName: string}) => {
                        return {
                            enableRowLink: true,
                            to: `/cdb-admin/container-images/${i.imageName}`
                        };
                    }}
                />
                
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): ContainerImageDashboardPageProps => {

        return {
            apiService: state.auth.apiService
        };
    }
)(ContainerImageDashboardPage)